import alt from "../alt";

class CreditActions {
  constructor() {
    this.generateActions("reset", "fetchCredits", "fetchFailed");
  }
}

export default alt.createActions(CreditActions);



// WEBPACK FOOTER //
// ./src/app/actions/CreditActions.js